import { render, staticRenderFns } from "./ManageBuildingsPage.vue?vue&type=template&id=292905d2&scoped=true&"
import script from "./ManageBuildingsPage.vue?vue&type=script&lang=js&"
export * from "./ManageBuildingsPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageBuildingsPage.vue?vue&type=style&index=0&id=292905d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292905d2",
  null
  
)

export default component.exports